import { useDrop, useDrag } from "react-dnd";

export const useTaskDrag = (task, selectedTasks) => {
  const [{ isDragging }, dragRef] = useDrag({
    type: "TASK",
    item: { taskId: task.id, selectedTasks },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return { dragRef, isDragging };
};

export const useBoardDrop = (boardId, moveTask) => {
  const [{ isOver }, dropRef] = useDrop({
    accept: "TASK",
    drop: (item) => {
      const idsToMove = item.selectedTasks.length > 0
        ? item.selectedTasks
        : [item.taskId];

      idsToMove.forEach((id) => moveTask(id, boardId));
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return { dropRef, isOver };
};
